import React from 'react';
import PropTypes from 'prop-types';
import Button from 'relements/build/esm/ui/button';
import Icon from 'relements/build/esm/ui/icon';
import Toggle from 'relements/build/esm/input/toggle';
import Search from 'relements/build/esm/input/search';

import styles from './DictionaryHeader.scss';

export default class DictionaryHeader extends React.Component {
  static propTypes = {
    onFilter: PropTypes.func,
    filters: PropTypes.shape({
      onlyEmptyVariants: PropTypes.bool,
      searchTerm: PropTypes.string,
      page: PropTypes.number,
      pageSize: PropTypes.number,
    }),
  };

  render() {
    return (
      <div className={styles.header}>
        {this.renderInfoText()}
        <div className={styles.headerActions}>
          {this.renderSearch()}
          {this.renderEmptyVariantsToggle()}
          {this.renderCTAs()}
        </div>
      </div>
    );
  }

  renderInfoText() {
    return (
      <div className={styles.headerInfo}>
        <Icon
          src="info"
          className={styles.headerInfoIcon}
        />
        <div className={styles.headerInfoText}>
          Dictionary is a collection of WORDS (used to make API calls) and
          VARIANTS (all possible variantions users can type for a word while
          chatting)
        </div>
      </div>
    );
  }

  renderSearch() {
    const disabledClassName = this.props.filtersDisabled
      ? styles.filtersDisabled
      : '';
    return (
      <div className={styles.headerActionsSearch}>
        <Search
          placeholder="Search word or variant"
          className={`${styles.headerActionsSearch} ${disabledClassName}`}
          hint="⏎ Press enter to search" 
          value={this.props.filters.searchTerm}
          onSubmit={(e) => {
            this.props.onFilter('searchTerm', e.target.value)
          }}
        />
      </div>
    );
  }

  renderEmptyVariantsToggle() {
    const disabledClassName = this.props.filtersDisabled
      ? styles.filtersDisabled
      : '';
    return (
      <div className={`${styles.headerActionsToggle} ${disabledClassName}`}>
        <Toggle
          value={this.props.filters.onlyEmptyVariants}
          onChange={onlyEmptyVariants =>
            this.props.onFilter('onlyEmptyVariants', onlyEmptyVariants)
          }
          className={styles.headerActionsToggleKnob}
        />
        <div className={styles.headerActionsToggleLabel}>
          Show only empty Variants
        </div>
      </div>
    );
  }

  renderCTAs() {
    return (
      <div className={styles.headerActionsCTAs}>
        <Button
          disabled={this.props.filtersDisabled}
          onClick={this.props.onDownload}
          className={styles.headerActionsCTA}
        >
          Backup
        </Button>
        {
          this.props.onUpload ?
          <Button
            disabled={this.props.filtersDisabled}
            onClick={this.props.onUpload}
            className={styles.headerActionsCTA}
          >
            Replace & Upload
          </Button>
          : null
        }
      </div>
    );
  }
}
